import { render } from "./SelectedCandidates.vue?vue&type=template&id=ad9e804e&scoped=true"
import script from "./SelectedCandidates.vue?vue&type=script&lang=js"
export * from "./SelectedCandidates.vue?vue&type=script&lang=js"

import "./SelectedCandidates.vue?vue&type=style&index=0&id=ad9e804e&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9e804e"]])

export default __exports__